import { Button } from '@mui/material';
import React from 'react';
import Box from 'react-layout-components';

import useTranslation from '../../components/hooks/useTranslation';
import Typography from '../../components/typography/Typography';
import FooterContainer from '../../container/Footer/FooterContainer';
import HeaderContainer from '../../container/Header/HeaderContainer';
import Page from '../Page/Page';
import PageContent from '../Page/PageContent';

interface Props {
  onResolve: () => void;
}

function ErrorPage(props: Props) {
  const { onResolve } = props;
  const translatedStrings = useTranslation();
  return (
    <Page>
      <HeaderContainer title={translatedStrings.errorOccurred} hasError />
      <PageContent>
        <Box column flex="1 1 auto" center>
          <Box column>
            <Typography variant="h2">{translatedStrings.errorPageMessage}</Typography>
            <Box justifyContent="flex-end">
              <Button variant="contained" color="primary" onClick={onResolve}>
                {translatedStrings.errorPageAction}
              </Button>
            </Box>
          </Box>
        </Box>
      </PageContent>
      <FooterContainer />
    </Page>
  );
}

export default ErrorPage;
